import { createContext, useState, useContext, PropsWithChildren, useEffect } from 'react';
import {
  CompanyGdprSettingsDTO,
  CandidateAccessDTO,
  getCandidateDetailsForGDPR,
  IJobCandidateInteractionResponse,
  ICandidate,
} from 'wisestep-api';

interface GDPRContextData {
  settings?: CompanyGdprSettingsDTO | null;
  accessInfo?: CandidateAccessDTO | null;
  aggregatedData?: any;
  candidateData?: IJobCandidateInteractionResponse & ICandidate;
}
export const CandidateDataContext = createContext<GDPRContextData | null>(null);

export default function CandidateDataProvider(props: PropsWithChildren<GDPRContextData | null>) {
  const [GDPRData, setGDPRData] = useState<GDPRContextData | null>({
    settings: null,
    accessInfo: null,
    aggregatedData: null,
    candidateData: undefined,
  });

  useEffect(() => {
    const fetchCandidateAccess = async () => {
      let interactionResponse;
      try {
        interactionResponse = await getCandidateDetailsForGDPR(
          props.accessInfo?.email ?? '',
          props.settings?.workspaceIdsToUseForCandidateInfoSearch?.[0] ?? ''
        );
      } catch (e) {
        console.log('candidate data not found');
      }

      setGDPRData({
        aggregatedData: [],
        settings: props.settings,
        accessInfo: props.accessInfo,
        candidateData: interactionResponse?.data,
      });
    };

    fetchCandidateAccess();
  }, [props.accessInfo, props.settings]);

  return (
    <CandidateDataContext.Provider value={{ ...GDPRData }}>
      {props.children}
    </CandidateDataContext.Provider>
  );
}

export function useCandidateGDPRDataContext() {
  const context = useContext(CandidateDataContext);
  if (!context) {
    throw new Error('useCandidateGDPRDataContext must be used within the CandidateDataProvider');
  }
  return context;
}
